/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

const is = require("is_js");

const { LoggerModule } = require("@vlinder-web/logger-module-react");
const SERVICE_NAME = "traffic-light.service";
const log: any = LoggerModule.getInstance();

export class TrafficLightService {
    name = SERVICE_NAME;
    private static instance: TrafficLightService;
    private constructor() {
        this.report();
    }

    static getInstance() {
        if (!this.instance) {
            this.instance = new TrafficLightService();
        }
        return this.instance;
    }
    async init() {}

    async handleGreen() {
        await new Promise((r) => setTimeout(r, 30000));
        //Any other logic like pedestrain etc.
        return "Green service check";
    }

    async handleAmber() {
        await new Promise((r) => setTimeout(r, 10000));
        //Any other logic like pedestrain etc.
        return "Amber Service check";
    }

    async handleRed() {
        await new Promise((r) => setTimeout(r, 30000));
        //Any other logic like pedestrain etc.
        return "Red Service check";
    }

    private report() {
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
        log?.info(SERVICE_NAME, "Module Report");
        log?.info(SERVICE_NAME, "⦿ Name: " + this.name);
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
    }
}
